<template>
  <div
    v-if="!disabled"
    :style="style"
  >
    <el-form-item
      :label="title"
      :style="styleForm"
      :prop="prop"
    >
      <el-input
        v-model="internalValue"
        :placeholder="placeholder"
        :class="{ 'highlight': highlight }"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        @keydown.tab="handleTabKey"
      />
    </el-form-item>
  </div>
    
    
  <div
    v-if="disabled"
    :style="style"
  >
    <el-form-item
      :label="title"
      :style="styleForm"
      :prop="prop"
    >
      <el-input
        v-model="internalValue"
        :placeholder="placeholder"
        disabled
        :class="{ 'highlight': highlight }"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        @keydown.tab="handleTabKey"
      />
    </el-form-item>
  </div>
</template>
    
    <script>
    
    export default {
      props: {
        title: {
          type: String,
          required: false,
        },
        label: {
          type: String,
          required: true,
        },    
        prop: {
          type: String,
          required: false,
        },
        placeholder: {
          type: String,
          required: true,
        },
        value: {
          type: String,
          required: true,
        },
        span: {
          type: Number,
          required: false,
          default: 3,
        },
        style: {
          type: String,
          required: false,
        },
        styleForm: {
          type: String,
          required: false,
        },
        highlight: {
          type: Boolean,
          require: false,
        },
    
        divWidth:{
          type:String
        },
        disabled:{
          type:Boolean,
          default:false
        }
      },
      data() {
        return {
          internalValue: this.value,
          fieldsOfInterest: ['address', 'cap', 'province', 'street_number', 'city'],
        };
      },
      watch: {
        value(newValue) {
          this.internalValue = newValue;
        }
      },
      methods: {
    
        handleInputFocus() {
          this.$emit('focus');
        },
        handleInputBlur(){
          this.$emit('blur');
          this.$emit('input', this.internalValue);
        },
        handleTabKey() {
        this.handleInputBlur();
      }
      
      },
    };
    </script>
    
    <style scoped>
    
    .highlight {
      border: 2px solid rgb(205, 54, 54); 
    }
    </style>
    